<template>
    <Button
        v-bind="$attrs"
        :disabled="submitting || disabled || !formIsValid"
        :type="type"
        :variant="variant"
        v-on="$listeners"
    >
        <v-progress-circular v-show="submitting" indeterminate size="20" class="mr-2" />
        <span v-show="submitting && submittingText">{{ submittingText }}</span>
        <slot v-if="!submittingText || !submitting"></slot>
    </Button>
</template>

<script lang="ts">
    import { defineComponent } from "vue"
    import { useVCForm } from "@/components/form/Form.api"

    export default defineComponent({
        props: {
            disableOnInvalidForm: Boolean,
            disabled: {
                type: Boolean,
                default: false,
            },
            submitting: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: "primary",
            },
            submittingText: {
                type: String,
            },
            type: {
                type: String,
                default: "submit",
            },
        },
        setup() {
            return {
                vcform: useVCForm(),
            }
        },
        computed: {
            formIsValid() {
                if (!this.disableOnInvalidForm) {
                    return true
                }

                if (!this.vcform) {
                    return true
                }

                return this.vcform.isValid()
            },
        },
    })
</script>
